import React from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";

import {fetchCurrentUser, updateCurrentUser} from "../../../../creators/currentUser";

import {config} from "../../../../config";
import {Button} from "../../../components/Button";
import Title from "../../../components/Title";
import {PageLoader} from "../../../components/Loader";
import MeetInformationsSettings from "./MeetInformationsSettings";
import {CheckboxInputField, RadioInputField, SelectField} from "../../../components/FormField";
import {fetchLocationCountries} from "../../../../creators/locations.countries";
import {fetchLocationRegions, resetLocationRegions} from "../../../../creators/locations.regions";
import {fetchLocationCities, resetLocationCities} from "../../../../creators/locations.cities";
import {fetchLocationCounties, resetLocationCounties} from "../../../../creators/locations.counties";
import Helmet from "react-helmet";
import Toggle from "../../../components/Toggle";
import _ from "lodash";

class ProfilMeetSettings extends React.Component {
    constructor(props) {
        super(props);
        this.location = {
            country: {
                _id: 0,
                name: ""
            },
            region: {
                _id: 0,
                name: ""
            },
            county: {
                _id: 0,
                name: ""
            },
            city: {
                _id: 0,
                name: ""
            }
        };
        this.state = {
            lookingFor: [],
            tendencies: [],
            mobility: 0,
            civilStatus: 0,
            location: this.location,
            informations: [],
            appearInDating : false
        };
        this.handleLocation = this.handleLocation.bind(this);
        this.handleCheckbox = this.handleCheckbox.bind(this);
        this.handleProfileInformations = this.handleProfileInformations.bind(this);
    }

    componentDidMount(oldProps) {
        this.props.fetchCurrentUser();
        const newProps = this.props;
        if ((oldProps && oldProps.currentUserInitialized !== newProps.currentUserInitialized) || newProps.currentUserInitialized === true) {
            let profile = newProps.currentUser.profile;
            let setting = newProps.currentUser.setting;
            this.setState({
                lookingFor: profile.lookingFor || [],
                mobility: profile.mobility || 0,
                tendencies: profile.tendencies || [],
                civilStatus: profile.civilStatus || 0,
                location: newProps.currentUser.location,
                informations: profile.informations || [],
                appearInDating : setting.appearInDating || false
            });
        }
        this.props.fetchLocationCountries({
            countries: true,
            limit: false
        });
        if (this.props.currentUser.location) {
            if (this.props.currentUser.location.country && this.props.currentUser.location.country._id) {
                this.props.fetchLocationRegions({
                    parentTypeId: this.props.currentUser.location.country._id,
                    regions: true,
                    limit: false,
                    sort : "name"
                });
            }
            if (this.props.currentUser.location.region && this.props.currentUser.location.region._id) {
                this.props.fetchLocationCounties({
                    parentTypeId: this.props.currentUser.location.region._id,
                    counties: true,
                    limit: false,
                    sort : "name"
                });
            }
            if (this.props.currentUser.location.county && this.props.currentUser.location.county._id) {
                this.props.fetchLocationCities({
                    parentTypeId: this.props.currentUser.location.county._id,
                    cities: true,
                    limit: false,
                    sort : "name"
                });
            }
        }
    }

    handleCheckbox(name, id) {
        let stateName = this.state[name];
        if (stateName.includes(id)) {
            stateName = stateName.filter(item => item !== id);
        } else {
            stateName.push(id)
        }
        this.setState({[name]: stateName})
    }


    handleProfileInformations(id, name, value) {
        let informations = this.state.informations;
        let informationIndex = informations.findIndex(item => item._id === id);
        if (name === "personality") {
            if (!informations[informationIndex][name].includes(parseInt(value))) {
                informations[informationIndex][name].push(parseInt(value));
                this.setState({informations});
            } else {
                informations[informationIndex][name] = informations[informationIndex][name].filter(item => item !== value);
                this.setState({informations});
            }
        } else {
            informations[informationIndex][name] = parseInt(value);
            this.setState({informations});
        }
    }


    handleLocation(event) {
        if (event.target.name === "country") {
            let country = this.props.countries.find(elem => elem._id.toString() === event.target.value.toString()) || {};
            this.props.fetchLocationRegions({parentTypeId: country._id, regions: true, limit: false, sort : "name"});
            this.setState({location: {...this.location, country: {_id: country._id, name: country.name}, region: {_id: "", name: ""}, county: {_id: "", name: ""}, city: {_id: "", name: ""}, coordinate : {type : "Point", coordinates : [0,0]}}});
        }
        if (event.target.name === "region") {
            let region = this.props.regions.find(elem => elem._id.toString() === event.target.value.toString()) || {};
            this.props.fetchLocationCounties({parentTypeId: region._id, counties: true, limit: false, sort : "name"});
            this.setState({location: {...this.state.location, region: {_id: region._id, name: region.name}, county: {_id: "", name: ""}, city: {_id: "", name: ""}, coordinate : {type : "Point", coordinates : [0,0]}}});
        }
        if (event.target.name === "county") {
            let county = this.props.counties.find(elem => elem._id.toString() === event.target.value.toString()) || {};
            this.props.fetchLocationCities({parentTypeId: county._id, cities: true, limit: false, sort : "name"});
            this.setState({location: {...this.state.location, county: {_id: county._id, name: county.name}, city: {_id: "", name: ""}, coordinate : {type : "Point", coordinates : [0,0]}}});
        }
        if (event.target.name === "city") {
            let city = this.props.cities.find(elem => elem._id.toString() === event.target.value.toString()) || {};
            this.setState({
                location: {
                    ...this.state.location,
                    city: {
                        _id: city._id,
                        name: city.name
                    },
                    coordinate : city.coordinate
                }
            });
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        let currentUser = {
            profile: {
                lookingFor: this.state.lookingFor,
                tendencies: this.state.tendencies,
                mobility: this.state.mobility,
                civilStatus: this.state.civilStatus,
                informations: this.state.informations,
            },
            setting : {
                appearInDating : this.state.appearInDating
            },
            location: this.state.location,
        };
        if (!this.props.currentUserLoading) {
            this.props.updateCurrentUser(currentUser);
        }
    }

    render() {
        let isErrorIsDating = "";
        let isAppearInDating = _.get(this.props.currentUser,"setting.appearInDating") || false;
        let description = _.get(this.props.currentUser,"profile.description") || "";
        let lookFor = _.get(this.props.currentUser,"profile.lookingFor") || [];
        let birthday = _.get(this.props.currentUser,"profile.informations[0].birthday") || "";

        if(description === ""){
            isErrorIsDating = "Vous devez remplir une description";
        }
        else if(lookFor.length === 0){
            isErrorIsDating = "Vous devez au moins selectionné un genre de recherche";
        }

        else if(birthday === ""){
            isErrorIsDating = "Vous devez au moins renseigner une date de naissance ";
        }

        let classToggle = isAppearInDating && isErrorIsDating === "" ? "active" : "active warning-toggle";


        return !this.props.currentUserInitialized ? <PageLoader/> : (
            <div className="settings-wrapper">
                <Helmet>
                    <title>{config.preTitle}Paramètres de rencontre{config.postTitle}</title>
                </Helmet>

                <form className="block" onSubmit={(e) => this.handleSubmit(e)}>
                    <Title className={"settings-title"} heading={"heading-2"} display={"display-2"}>Rencontre</Title>
                    <div className={"content"}>
                        <div className={`no-content ${this.state.appearInDating ? classToggle : ''}`}>
                          <span className="column mr-32">
                            Afficher vos informations dans la section rencontre ?
                            <span className="f-size-10 mt-4 validate-toggle-displayInMeet">
                                <span>{isErrorIsDating === "" ? "(votre annonce de rencontre est bien visible par les voissanautes)" : `(${isErrorIsDating})` }</span>
                            </span>
                          </span>
                            <Toggle isToggled={this.state.appearInDating}
                                    onToggle={() => this.setState({appearInDating : !this.state.appearInDating})}/>
                        </div>
                        <div className="settings-sub-title mt-24">Recherche</div>
                        <div className="profil-meet-content">
                            {config.lookingFor.map((name, lookingForIndex) => {
                                if (lookingForIndex > 0) {
                                    return (
                                        <CheckboxInputField checked={this.state.lookingFor.includes(lookingForIndex)}
                                                            onChange={() => this.handleCheckbox("lookingFor", lookingForIndex)}
                                                            htmlFor={`lookingFor_${lookingForIndex}`}
                                                            id={`lookingFor_${lookingForIndex}`}
                                                            label={name}
                                                            classNameLabel={"cursor-pointer"}
                                                            value={lookingForIndex}
                                                            key={lookingForIndex}/>
                                    )
                                } else return null;
                            })}
                        </div>

                        <div className="settings-sub-title">Tendance</div>
                        <div className="profil-meet-content">
                            {config.tendencies.map((name, tendenciesIndex) => {
                                if (tendenciesIndex > 0) {
                                    return (
                                        <CheckboxInputField checked={this.state.tendencies.includes(tendenciesIndex)}
                                                            onChange={() => this.handleCheckbox("tendencies", tendenciesIndex)}
                                                            htmlFor={`tendencies_${tendenciesIndex}`}
                                                            id={`tendencies_${tendenciesIndex}`}
                                                            label={name}
                                                            classNameLabel={"cursor-pointer"}
                                                            value={tendenciesIndex}
                                                            key={tendenciesIndex}/>
                                    )
                                } else return null;
                            })}
                        </div>
                        <div className="settings-sub-title">Mobilité</div>
                        <div className="profil-meet-content">
                            {config.mobility.map((name, mobilityIndex) => (
                                <RadioInputField checked={this.state.mobility === mobilityIndex}
                                                 onChange={() => this.setState({mobility: mobilityIndex})}
                                                 htmlFor={`mobility_${mobilityIndex}`}
                                                 id={`mobility_${mobilityIndex}`}
                                                 label={name}
                                                 key={mobilityIndex}/>
                            ))}
                        </div>
                        <div className="settings-sub-title">Statut marital</div>
                        <div className="profil-meet-content">
                            {config.civilStatus.map((name, civilStatusIndex) => (
                                <RadioInputField checked={this.state.civilStatus === civilStatusIndex}
                                                 onChange={() => this.setState({civilStatus: civilStatusIndex})}
                                                 htmlFor={`civilStatus_${civilStatusIndex}`}
                                                 id={`civilStatus_${civilStatusIndex}`}
                                                 label={name}
                                                 key={civilStatusIndex}/>
                            ))}
                        </div>

                        <div className="settings-sub-title">Localisation</div>
                        <div className={"profil-meet-content"}>
                            <SelectField name={"country"}
                                         value={this.state.location.country && this.state.location.country._id}
                                         onChange={(event) => this.handleLocation(event)}>
                                <option value="">Pays</option>
                                {this.props.countries.map((item) => <option value={item._id}
                                                                            key={item._id}>{item.name}</option>)}
                            </SelectField>

                            <SelectField name={"region"}
                                         value={this.state.location.region && this.state.location.region._id}
                                         onChange={(event) => this.handleLocation(event)}>
                                <option value="">Région</option>
                                {this.props.regions.map((item) => <option value={item._id}
                                                                          key={item._id}>{item.name}</option>)}
                            </SelectField>

                            <SelectField name={"county"}
                                         value={this.state.location.county && this.state.location.county._id}
                                         onChange={(event) => this.handleLocation(event)}>
                                <option value="">Département</option>
                                {this.props.counties.map((item) => <option value={item._id}
                                                                           key={item._id}>{item.name}</option>)}
                            </SelectField>

                            <SelectField name={"city"} value={this.state.location.city && this.state.location.city._id}
                                         onChange={(event) => this.handleLocation(event)}>
                                <option value="">Ville</option>
                                {this.props.cities.map((item) => <option value={item._id}
                                                                         key={item._id}>{item.name}</option>)}
                            </SelectField>
                        </div>

                        <label className="label-title">Tableau info</label>

                        <div className={"flex-table"}>
                            <div className={"row flex-1"}>
                                {this.state.informations.map((information, index) => (
                                    <MeetInformationsSettings key={index}
                                                              information={information}
                                                              informationsLength={this.state.informations.length}
                                                              handleProfileInformations={this.handleProfileInformations}
                                                              index={index}/>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="settings-btn-group">
                        <Button size={"medium"}
                                btnStyle={"primary-reverse"}
                                btnType={"submit"}
                                loading={this.props.currentUserSubmitting}
                                content={"Enregistrer"}/>
                    </div>
                </form>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserSubmitting: state.currentUser.submitting,
        currentUserInitialized: state.currentUser.initialized,
        countries: state.locationCountries.data,
        regions: state.locationRegions.data,
        counties: state.locationCounties.data,
        cities: state.locationCities.data,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCurrentUser,
    updateCurrentUser,

    fetchLocationCountries,
    fetchLocationRegions,
    fetchLocationCounties,
    fetchLocationCities,
    resetLocationRegions,
    resetLocationCounties,
    resetLocationCities
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProfilMeetSettings);